export default __webpack_public_path__ + "static/AppLocation2-45d18608070d33c0d961a7b3f88d94de.png";